module.exports = __webpack_public_path__ + "alien.png?c205fa4a0e28b4d067eefb9da373eb20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alien.png
// module id = 97
// module chunks = 0